/**
 * @author: Theralytics
 * @uses: To show header data
 * @desc: Notification commented intentionally for further use(*-Do not remove).
 */

import { Field, reduxForm } from 'redux-form';
import React, { Component } from 'react';
import AvatarDropdown from '../components/avatarDropdown.js';
import { connect } from 'react-redux';
// import { getUserLocations } from '../modules/users/actions/UserActions';
import { changeLocationAction } from '../modules/logins/actions/LoginActions';
import { getPatientsByFirstCharacter, getPatientsByFilter } from '../modules/patients/actions/PatientActions';
// import { getMasterData } from '../modules/Dashboards/actions/StaffDashboardActions';
// import { getAppConfigList } from '../modules/AppConfig/actions';
// import Notification from './notification.js';
import MenuItem from 'material-ui/MenuItem';
import { renderAutoCompleteSingleSelectHeader } from '../components/reduxFields';
import history from '../history';
import GlobalVariables from '../actions/utilAction';
import avatarImage from '../img/doctor.png';
import Favicon from 'react-favicon';

const names = [
  'Alaska',
  'California',
  'Florida',
  'New York',
  'Washington',
  'Ontario',
];
class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      values: [],
      isFirstTime: true,
      // locations: [],
    };
    this.handleNewRequest = this.handleNewRequest.bind(this);
  }


  componentWillReceiveProps(nextProps) {
    
    GlobalVariables.CurrentLocationId = nextProps.locationId;
    // this.props.changeLocationAction(nextProps.locationId, this.props.loginUserInfo, this.props.userPermission, this.props.appConfigurations, this.props.userLocationList);
    if (this.state.isFirstTime || (nextProps.locationId && nextProps.locationId !== this.props.locationId)) {
      this.props.getPatientsByFilter('startwith', '', '&isactive=true', nextProps.locationId, false, this.props.viewTeamClientsOnlyPermission);
      this.setState({ isFirstTime: false });
    }
    if (nextProps.locationId && nextProps.locationId !== this.props.locationId) {
      history.push('/dashboard');
    }

  }

  handleChange = (event, index, values) => {
    this.setState({ values });
  };

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
    // console.log('selectedRecord.value............', selectedRecord.value);
    GlobalVariables.CurrentLocationId = selectedRecord.value;
    this.props.changeLocationAction(selectedRecord.value, this.props.loginUserInfo, this.props.userPermission, this.props.appConfigurations, this.props.userLocationList);
    this.props.getPatientsByFilter('startwith', '', '&isactive=true', selectedRecord.value, false, this.props.viewTeamClientsOnlyPermission);
  }

  menuItems(values) {
    if (names.length) {
      return names.map((name) => (
        <MenuItem
          key={name}
          insetChildren={true}
          checked={values && values.indexOf(name) > -1}
          value={name}
          primaryText={name}
        />
      ));
    }
  }
  render() {
    const style = {
      background: this.props.colorHeaderBanner.color,
    };

    let userImage = avatarImage
      , welcomeNote = '';
    if (this.props.loginUserInfo) {
      let { photoThumbnailPath, firstName } = this.props.loginUserInfo;
      userImage = photoThumbnailPath || avatarImage;
      welcomeNote = `Welcome, ${firstName}`;
    }

    // const { values } = this.state;
    return (
      <header style={style} className="an-header">
        <Favicon url={this.props.organizationDetails && this.props.organizationDetails.favicon ? this.props.organizationDetails.favicon : ''} />
        <div className="col-4 col-sm-4 col-md-4 col-lg-3 col-xl-2 haedloc">
          <div >
            <Field
              name="Location"
              label="Location"
              handleNewRequest={this.handleNewRequest}
              options={this.props.userLocationList}
              component={renderAutoCompleteSingleSelectHeader}/>
          </div>

          <div >

          </div>
        </div>
        <div className="header-right">
          {/* <Notification/>*/}
          <div className="welcomeName">{welcomeNote}</div>
          <AvatarDropdown userImage={userImage} welcomeNote={welcomeNote} />

        </div>
      </header>
    );
  }
}

function mapStateToProps(state) {

  // let currentLocationId = state.login.currentLocationId > 0 ? state.login.currentLocationId : state.user.currentLocationId
  // state.login.currentLocationId = currentLocationId

   // Start For Role Permission
   let userScreenPermission = [];
   if (state.login.userPermission) {
     let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
     userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
   }
 
   let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
 
   let viewTeamClientsOnlyPermission = hasDefaultAccess ? false : userScreenPermission ? userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY')[0].permission : false;
   // End For Role Permission

  let initialData = {
    Location: state.login.currentLocationId,
  };

  // let app_config = state.appConfig.appConfigList;
  // let pageSize = GlobalVariables.PageSize;

  // if (app_config && app_config.data) {
  //   app_config.data.map((Obj) => {
  //     if (Obj.attributes.ConfigType === 2) {
  //       switch (Obj.attributes.Key) {
  //       case 'PAGE_SIZE':
  //         return pageSize = Obj.attributes.Value;
  //         break;
  //       }
  //     }
  //   });
  // }


  return {
    initialValues: initialData,
    colorHeaderBanner: state.headerBAnnerActiveStyle,
    // patientMaster: state.patient.master_data,
    // userMaster: state.user.master_data,
    userLocations: state.user.userLocations,
    // staffList: state.user.staffList,
    // userLocationList: state.user.userLocationList,
    loginUserInfo: state.login.loginUserInfo,
    // pageSize: pageSize,
    locationId: state.login.currentLocationId,
    userPermission: state.login.userPermission,
    // userMaster: state.staff_dashboard.master_data,
    appConfigurations: state.login.appConfigurations,
    userLocationList: state.login.userLocationList,
    organizationDetails: state.login.organizationDetails,
    viewTeamClientsOnlyPermission: viewTeamClientsOnlyPermission,
  };
}

Header = reduxForm({
  form: 'HeaderForm',
  enableReinitialize: true,
})(Header);

export default connect(mapStateToProps, { changeLocationAction, getPatientsByFirstCharacter, getPatientsByFilter })(Header);



// WEBPACK FOOTER //
// ./src/containers/header.js